(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-announcement]').forEach(function (bar) {
  // Close works in both modes
  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-announcement-close]')) { bar.remove(); }
  });

  if (bar.dataset.mode === 'scroll') {
    setupMarquee(bar);
    return;
  }

  /* ---- rotating (fade) mode ---- */
  var items = bar.querySelectorAll('.announcement__item');
  if (!items.length) return;
  var index = 0;
  var timer = null;

  function show(i) {
    index = (i + items.length) % items.length;
    items.forEach(function (item, n) { item.classList.toggle('is-active', n === index); });
  }
  function start() {
    if (bar.dataset.autorotate !== 'true' || items.length < 2) return;
    stop();
    timer = setInterval(function () { show(index + 1); }, (parseInt(bar.dataset.speed, 10) || 5) * 1000);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  show(0);
  start();
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-announcement-prev]')) { show(index - 1); start(); }
    if (e.target.closest('[data-announcement-next]')) { show(index + 1); start(); }
  });
});

function setupMarquee(bar) {
  var marquee = bar.querySelector('[data-marquee]');
  var inner = bar.querySelector('.announcement__inner');
  if (!marquee) return;

  function build() {
    if (!marquee.dataset.original) { marquee.dataset.original = marquee.innerHTML; }
    var setHTML = marquee.dataset.original;

    // measure one set
    marquee.innerHTML = setHTML;
    var setWidth = marquee.scrollWidth || 1;
    var containerW = (inner ? inner.clientWidth : window.innerWidth) || 1;

    // repeat the set enough to overflow the bar, then duplicate -> seamless -50% loop
    var reps = Math.max(1, Math.ceil(containerW / setWidth));
    var half = '';
    for (var i = 0; i < reps; i++) { half += setHTML; }
    marquee.innerHTML = half + half;

    // duration from desired pixels-per-second
    var halfWidth = marquee.scrollWidth / 2;
    var pxPerSec = parseFloat(bar.dataset.scrollSpeed) || 60;
    var dur = Math.max(5, halfWidth / pxPerSec);
    marquee.style.setProperty('--marquee-dur', dur + 's');
  }

  build();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-banner]').forEach(function (root) {
if (root.dataset.bannerBound) return;
root.dataset.bannerBound = '1';
var slides = root.querySelectorAll('[data-banner-slide]');
var dots = root.querySelectorAll('[data-banner-dot]');
if (slides.length < 1) return;
var index = 0;
var timer = null;
var speed = (parseInt(root.dataset.speed, 10) || 6) * 1000;
root.style.setProperty('--fill-time', (speed / 1000) + 's');
function show(i) {
index = (i + slides.length) % slides.length;
slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
dots.forEach(function (d, n) {
d.classList.remove('is-active');
d.setAttribute('aria-selected', n === index ? 'true' : 'false');
});
if (dots[index]) {
var fill = dots[index].querySelector('.banner__dot-fill');
if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
dots[index].classList.add('is-active');
}
}
function start() {
if (root.dataset.autoplay !== 'true' || slides.length < 2) return;
stop();
timer = setInterval(function () { show(index + 1); }, speed);
}
function stop() { if (timer) { clearInterval(timer); timer = null; } }
show(0);
start();
root.addEventListener('mouseenter', stop);
root.addEventListener('mouseleave', start);
root.addEventListener('focusin', stop);
root.addEventListener('click', function (e) {
if (e.target.closest('[data-banner-prev]')) { show(index - 1); start(); }
if (e.target.closest('[data-banner-next]')) { show(index + 1); start(); }
var dot = e.target.closest('[data-banner-dot]');
if (dot) { show(parseInt(dot.dataset.bannerDot, 10)); start(); }
});
var startX = null;
root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
root.addEventListener('touchend', function (e) {
if (startX === null) return;
var delta = e.changedTouches[0].clientX - startX;
if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
startX = null;
start();
}, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bento-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bento [data-countdown]').forEach(function (el) {
if (el.dataset.bound) return;
el.dataset.bound = '1';
var end = new Date(el.dataset.end).getTime();
if (isNaN(end)) return;
var units = el.querySelectorAll('.countdown__unit');
var expired = el.querySelector('.countdown__expired');
var d = el.querySelector('[data-cd-days]'), h = el.querySelector('[data-cd-hours]'),
m = el.querySelector('[data-cd-mins]'), s = el.querySelector('[data-cd-secs]');
function pad(n) { return String(n).padStart(2, '0'); }
function tick() {
var left = end - Date.now();
if (left <= 0) {
units.forEach(function (u) { u.hidden = true; });
if (expired && expired.textContent.trim()) expired.hidden = false;
clearInterval(timer); return;
}
d.textContent = pad(Math.floor(left / 86400000));
h.textContent = pad(Math.floor(left % 86400000 / 3600000));
m.textContent = pad(Math.floor(left % 3600000 / 60000));
s.textContent = pad(Math.floor(left % 60000 / 1000));
}
tick();
var timer = setInterval(tick, 1000);
});

document.querySelectorAll('.bento__reviews').forEach(function(rev){
if(rev.dataset.scrollInit)return;rev.dataset.scrollInit='1';
var items=Array.prototype.slice.call(rev.children);
if(items.length<3)return;
var track=document.createElement('span');track.className='bento__revtrack';
items.forEach(function(it){track.appendChild(it);});
items.forEach(function(it){track.appendChild(it.cloneNode(true));});
rev.appendChild(track);rev.setAttribute('data-bento-scroll','');
track.style.setProperty('--bento-rev-dur',(items.length*5)+'s');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-countdown]').forEach(function (el) {
  var end = new Date(el.dataset.end).getTime();
  if (isNaN(end)) return;
  var units = el.querySelectorAll('.countdown__unit');
  var expired = el.querySelector('.countdown__expired');
  var d = el.querySelector('[data-cd-days]'), h = el.querySelector('[data-cd-hours]'),
      m = el.querySelector('[data-cd-mins]'), s = el.querySelector('[data-cd-secs]');
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var left = end - Date.now();
    if (left <= 0) {
      units.forEach(function (u) { u.hidden = true; });
      if (expired && expired.textContent.trim()) expired.hidden = false;
      clearInterval(timer);
      return;
    }
    d.textContent = pad(Math.floor(left / 86400000));
    h.textContent = pad(Math.floor(left % 86400000 / 3600000));
    m.textContent = pad(Math.floor(left % 3600000 / 60000));
    s.textContent = pad(Math.floor(left % 60000 / 1000));
  }
  tick();
  var timer = setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-slideshow]').forEach(function (root) {
  var slides = root.querySelectorAll('[data-slide]');
  var dots = root.querySelectorAll('[data-slide-dot]');
  if (!slides.length) return;
  var index = 0, timer = null;

  function show(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); d.setAttribute('aria-selected', n === index); });
  }
  function start() {
    if (root.dataset.autoplay !== 'true' || slides.length < 2) return;
    stop();
    timer = setInterval(function () { show(index + 1); }, (parseInt(root.dataset.speed, 10) || 6) * 1000);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  show(0); start();
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-slide-prev]')) { show(index - 1); start(); }
    if (e.target.closest('[data-slide-next]')) { show(index + 1); start(); }
    var dot = e.target.closest('[data-slide-dot]');
    if (dot) { show(parseInt(dot.dataset.slideDot, 10)); start(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-address-toggle]');
  if (toggle) {
    var panel = document.getElementById(toggle.dataset.addressToggle);
    if (panel) panel.hidden = !panel.hidden;
    return;
  }
  var del = e.target.closest('[data-address-delete]');
  if (del) {
    if (!window.confirm(del.dataset.confirm || 'Delete this address?')) return;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = del.dataset.addressDelete;
    form.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(form);
    form.submit();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
(function () {
var popups = document.querySelectorAll('[data-popup]');
if (!popups.length) return;
var inEditor = window.Shopify && window.Shopify.designMode;
function storeKey(popup) { return 'momentum:popup:' + popup.dataset.popupId; }
function seen(popup) {
var freq = popup.dataset.frequency;
if (inEditor || freq === 'always') return false;
try {
if (freq === 'session') {
return !!sessionStorage.getItem(storeKey(popup));
}
var value = localStorage.getItem(storeKey(popup));
if (!value) return false;
if (freq === 'once') return true;
return (Date.now() - parseInt(value, 10)) < 86400000;
} catch (e) { return false; }
}
function remember(popup) {
try {
if (popup.dataset.frequency === 'session') {
sessionStorage.setItem(storeKey(popup), '1');
} else {
localStorage.setItem(storeKey(popup), String(Date.now()));
}
} catch (e) {}
}
function open(popup) {
if (seen(popup)) return;
popup.classList.add('is-open');
popup.setAttribute('aria-hidden', 'false');
document.body.classList.add('is-locked');
var focusable = popup.querySelector('input, button, a');
if (focusable) focusable.focus({ preventScroll: true });
}
function close(popup, save) {
popup.classList.remove('is-open');
popup.setAttribute('aria-hidden', 'true');
document.body.classList.remove('is-locked');
if (save !== false) remember(popup);
}
var gate = null;
popups.forEach(function (p) { if (p.hasAttribute('data-require-action')) gate = p; });
var gateCleared = !(gate && !seen(gate));
function clearGate() {
if (gateCleared) return;
gateCleared = true;
document.dispatchEvent(new CustomEvent('momentum:gate-cleared'));
}
popups.forEach(function (popup) {
var required = popup.hasAttribute('data-require-action');
popup.addEventListener('click', function (e) {
if (e.target.closest('[data-popup-confirm]')) { remember(popup); close(popup, false); clearGate(); return; }
if (e.target.closest('[data-popup-close]')) { close(popup); return; }
if (e.target === popup && !required) close(popup);
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !required && popup.classList.contains('is-open')) close(popup);
});
if (seen(popup)) return;
function arm() {
var trigger = popup.dataset.trigger;
if (trigger === 'immediate') {
open(popup);
} else if (trigger === 'delay') {
setTimeout(function () { open(popup); }, (parseInt(popup.dataset.delay, 10) || 3) * 1000);
} else if (trigger === 'scroll') {
var target = parseInt(popup.dataset.scroll, 10) || 40;
var onScroll = function () {
var pct = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
if (pct >= target) { open(popup); window.removeEventListener('scroll', onScroll); }
};
window.addEventListener('scroll', onScroll, { passive: true });
} else if (trigger === 'exit') {
document.addEventListener('mouseleave', function handler(e) {
if (e.clientY <= 0) { open(popup); document.removeEventListener('mouseleave', handler); }
});
}
}
if (required || gateCleared) {
arm();
} else {
document.addEventListener('momentum:gate-cleared', function once() {
document.removeEventListener('momentum:gate-cleared', once);
arm();
});
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-tabs]').forEach(function (root) {
  root.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var id = tab.dataset.tab;
    root.querySelectorAll('[data-tab]').forEach(function (t) {
      var on = t.dataset.tab === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === id);
    });
    if (window.Momentum && window.Momentum.scroller) window.Momentum.scroller.refresh();
  });
});

  } catch(e) { console.error(e); }
})();
})();
